import { useState, useEffect } from 'react';
import GridComponent from '../../../../component/grid/GridComponent.component';
import { useFormik } from 'formik';
import FormLabel from '../../../../component/input/FormLabel.component';
import Group from '../../groups/interfaces/Group';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../component/buttton/Button.component';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormInput } from '../../../../component/input/InputStyle';
import { useSnackbar } from '../../../../context/Snackbar';
import { getGroups } from '../../groups/Groups.service';
import { FormInterface } from '../../../../core/interfaces/form/Form';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function Form({ handleSubmitForm, initialValues }: FormInterface<Group>) {
  const { snackbar, setSnackbar } = useSnackbar();
  const [groups, setGroups] = useState<Group[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    getAllGroups();
  }, [snackbar]);

  const getAllGroups = async () => {
    try {
      setLoading(true);
      let groups: any[] = [];
      let page = 1;
      const res = await getGroups();
      groups = groups.concat(res.data.data);
      if (res.data.lastPage > page) {
        while (page < res.data.lastPage) {
          page++;
          const params = {
            page: page,
          };
          const res = await getGroups(params);
          groups = groups.concat(res.data.data);
        }
      }
      setGroups(groups);
      setLoading(false);
      return groups;
    } catch (e) {
      console.log('Erro ao consultar grupos!', e);
      setSnackbar({ msg: 'Erro ao consultar grupos!', type: 'error' });
      return [];
    }
  };

  const getGp = async (gpId: number, handleSubmitForm?: (values: Group) => void) => {
    const _all: Group[] = await getAllGroups();
    const gp = _all.find((g: Group) => g.id === gpId);
    if (gp) {
      handleSubmitForm &&
        handleSubmitForm({
          nome: gp.nome,
          id: gp.id,
          funcionalidades: gp.funcionalidades,
          created_at: gp.created_at,
          updated_at: gp.updated_at,
        });
    }
  };

  const { handleSubmit, setFieldValue } = useFormik<Group>({
    initialValues: initialValues,
    onSubmit: (values) => {
      values.id && getGp(values.id, handleSubmitForm);
    },
  });

  return (
    <form onSubmit={handleSubmit}>
      <GridComponent justify='flex-start' alignItems='flex-end' spacing={2}>
        <FormLabel title='Selecione o Grupo' sm={9} md={10}>
          <Autocomplete
            id='combo-box-gupos'
            size='small'
            options={groups}
            getOptionLabel={(option: Group) => option.nome}
            freeSolo
            onChange={(_event: React.ChangeEvent<any>, group: Group | any) => {
              setFieldValue('id', group?.id);
              setFieldValue('nome', group.nome);
              setFieldValue('funcionalidades', group.funcionalidades);
              setFieldValue('created_at', group.created_at);
              setFieldValue('updated_at', group.updated_at);
            }}
            renderInput={(params) => (
              <FormInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? <CircularProgress color='inherit' size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </FormLabel>
        <Grid item sm={3} md={2}>
          <Button title='Pesquisar' size='medium' />
        </Grid>
      </GridComponent>
    </form>
  );
}
